import AdminGuard from "./components/adminGuard";
import SiteNav from "./components/partial/SiteNav";
import StatChecker from "./components/statChecker";

export async function loader({ params }) {
    return params.id;
}

export const StatCheckerPage = () => {
    return (
        <>
            <AdminGuard>
                <SiteNav />
                <StatChecker />
            </AdminGuard>
            
        </>
    )
}
